import React from "react";
import styled from "styled-components";
import {connect} from "react-redux";
import {chatActions} from "_actions";
import {AppearFromBottom} from "global/style";

const ImageButton = styled(AppearFromBottom)`
border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  cursor: pointer;
  outline: none;
  border: 1px solid ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageBorderColor};
  border-radius: 8px;
  box-shadow: 0px 0px 6px rgba(180, 180, 180, 0.25);
  transition: all ${(props) => props.theme.themeColors[props.theme.activeTheme].transitionSpeed} ease-in-out;
  background: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageBackgroundColor};

  &:focus {
    outline: none;
  }

  &:hover {
    border: white;
    box-shadow: 0px 0px 6px rgba(122, 122, 122, 0.25);
    border-radius: 8px;
    & > div {
      color: ${(props) => props.theme.themeColors[props.theme.activeTheme].main}
    }                   
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    width: 120px;
    height: 120px;
  }
`;

const StyledImage = styled.img`
  height: 50px;

  @media(min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
        height: 58px;
  }
`;


const ImageText = styled.div`
  text-transform: capitalize;
  color: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageText};
  text-align: center;
  font-size: 13px;
  font-family: Poppins;
  @media(min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    font-size: 15px;
  } 
`
const ImageWrapper = styled.div`
   display:flex;
   align-items: flex-end;
`

function Image({data, send, activeTheme, newBranding}) {
  const handleClick = () => {
    send(data, "image");
  };

  const quickLinkClicked = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      send(data, "image");
    }
  };

  const isStudio = data.image && data.image.startsWith("0-");

  const imageBasePath = `/images/${activeTheme === "dark" ? "dark-mode" : "light-mode"}/quicklinks/`;
  let image;
  let imageText;
  const moreThanOneBedroom = data.image.match(/\d+/) && parseInt(data.image.match(/\d+/)[0]) > 1;
    if (data.image.includes("0")) {
       image = "0-bed.svg"
       imageText = isStudio ? "studio" : "bedroom";
       if(data.image.includes("es")){
        imageText = isStudio ? "estudio" : "habitacion";
       }
    } else {
        if(data.image.includes("es")){
          image= data.image.replace("-es", "");
          imageText = isStudio ? "estudio" : "habitacion";
          if (moreThanOneBedroom) {
            imageText = "habitaciones";
          }
        }
        else{
          imageText = isStudio ? "studio" : "bedroom";
          image= data.image;
          if (moreThanOneBedroom) {
            imageText = "bedrooms";
          }
        }
      }     
      if(newBranding === "1"){
        image = image.replace(".svg", "-green.svg");
      }
  const imageFullPath = `${imageBasePath}${image}`;



  return (
    <ImageButton
      className="ImageButton quicklinks"
      onClick={handleClick}
      tabIndex={0}
      role="button"
      data={data}
      onKeyPress={(e) => quickLinkClicked(e)}
    >
      <ImageWrapper>
        <StyledImage
          alt={data.value + " bedrooms image"}
          src={imageFullPath}
        />
      </ImageWrapper>
      <ImageText>{imageText}</ImageText>
    </ImageButton>
  );
}

const actions = {
  send: chatActions.send,
};

const mapStateToProps = (state) => ({
  activeTheme: state.settings.activeTheme,
  newBranding: state.settings.new_branding
});

export default connect(mapStateToProps, actions)(Image);
